import AbstractRequestTask from "../../AbstractRequestTask";
import Launcher from '../../../apa/Launcher';

class RefreshTokenOttV2Task extends AbstractRequestTask {
 
    getUrl() {
        const http = "https://";
        const url = Launcher.get("akamai_mfwk");
        return `${http}${url}/services/user/v2/refresh_token`;
    }

    getParams() {
        const params = super.getParams();
        delete params.HKS;
        delete params.api_version;
        delete params.format;
        delete params.user_token;

        return { ...params };
    }

    success(data, b) {
        this.resolve(data);
    }

    getRetriesNumber() {
        return 0;
    }

    isValid(data) {
        if (data.errors || !data.data || data.data === 'errors') {
            return false;
        }

        return true;
    }

    getHeaders() {
        const token = super.getParams().user_token
        return {
            Authorization: `Bearer ${token}`
        }
    }
}

export default RefreshTokenOttV2Task;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/v2/RefreshTokenOttV2Task.js